import {
  CompletedNeeds,
  DonateButtonLoader,
  Gallery,
  NeedList,
  Recommender,
  SharingContainer,
  Stats,
  Sticky,
} from 'ppp'
import {
  mountOnId,
  WirwunderLogoWhitener,
} from 'shared'


document.addEventListener("DOMContentLoaded", () => {
  mountOnId(Stats, 'ppp-stats')

  mountOnId(Sticky, 'ppp-sticky')

  mountOnId(NeedList, 'ppp-need-list')

  mountOnId(CompletedNeeds, 'ppp-completed-needs')

  mountOnId(Recommender, 'ppp-recommender')

  mountOnId(Gallery, 'ppp-gallery')

  mountOnId(SharingContainer, 'ppp-sharing')

  mountOnId(DonateButtonLoader, 'ppp-opinions-donate-button')

  mountOnId(WirwunderLogoWhitener, 'ppp-wirwunder-logo')

  if (typeof IntersectionObserver === 'function') {
    // sorry, IE https://caniuse.com/#feat=intersectionobserver
    new IntersectionObserver(
      function (entries, observer) {
        for (var _i = 0; _i < entries.length; _i++) {
          var stickyHeader = entries[_i].target.nextSibling
          stickyHeader.toggleAttribute('stuck', !entries[_i].isIntersecting)
        }
      },
      {}
    ).observe(document.getElementById('ppp-sticky-anchor'))
  }

})
